import React, { useState, useEffect } from "react";
import { FaArrowLeft, FaSave } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import AdminAppBody from "../../../../components/admin/AdminAppBody";
import useApiCallHooks from "../../../../hooks/useApiCallHooks";
import { toast } from "react-toastify";
import Select from "react-select";

const MentorAddGroup = () => {
    const [studentResponse, studentLoading, studentError, callStudentAPI] =
        useApiCallHooks();

    const [form, setForm] = useState({
        name: "",
        type: "",
        program_id: "",
        student_ids: [], // store only IDs
    });

    const [studentOptions, setStudentOptions] = useState([]);
    const [programOptions, setProgramOptions] = useState([]);

    const typeOptions = [
        { value: "student", label: "Student" },
        { value: "kids", label: "Kids" },
    ];

    const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();

    const navigate = useNavigate();

    const handleTypeChange = (selectedOption) => {
        const newType = selectedOption ? selectedOption.value : "";
        setForm({
            ...form,
            type: newType,
            program_id: "",
            student_ids: [],
        });

        if (newType) {
            callStudentAPI("get", `get-program-student-list/${newType}`);
        } else {
            setStudentOptions([]);
            setProgramOptions([]);
        }
    };

    const handleProgramChange = (selectedOption) => {
        setForm((prev) => ({
            ...prev,
            program_id: selectedOption ? selectedOption.value : "",
        }));
    };

    const handleStudentChange = (selectedOptions) => {
        const ids = selectedOptions
            ? selectedOptions.map((opt) => opt.value)
            : [];
        setForm((prev) => ({
            ...prev,
            student_ids: ids,
        }));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        callAPI("post", "mentor/create-group", form);
    };

    useEffect(() => {
        if (studentResponse?.data) {
            const mappedStudents = (studentResponse.data.students || []).map(
                (s) => ({
                    value: s.id,
                    label: s.first_name + " " + s.last_name,
                })
            );
            setStudentOptions(mappedStudents);

            const mappedPrograms = (studentResponse.data.programs || []).map(
                (p) => ({
                    value: p.id,
                    label: p.name,
                })
            );
            setProgramOptions(mappedPrograms);
        }
    }, [studentResponse]);

    // alert(statusCode)
  useEffect(() => {
    if (statusCode === 201) {
        toast.success("Mentor group created successfully!", {
            autoClose: 2000, // 2 seconds
            onClose: () => navigate("/mentor/groups-list"), // Navigate after toast closes
        });
    }
}, [statusCode, navigate]);

    return (
        <AdminAppBody
            content={
                <div className="container card mt-4 p-4">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h4>Add Group</h4>
                        <button
                            className="btn btn-primary"
                            onClick={() => navigate(-1)}
                        >
                            <FaArrowLeft className="me-1" /> Back
                        </button>
                    </div>
                    <hr />
                    <form onSubmit={handleSubmit}>
                        <div className="row mb-3">
                            <div className="col-4">
                                <label className="form-label">Group Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Group Name"
                                    name="name"
                                    value={form.name}
                                    onChange={handleChange}
                                />
                                <span className="val-message text-danger">
                                    {error?.message === "ValidationError" &&
                                        error?.data?.name}
                                </span>
                            </div>

                            <div className="col-4">
                                <label className="form-label">Type</label>
                                <Select
                                    name="type"
                                    value={
                                        typeOptions.find(
                                            (opt) => opt.value === form.type
                                        ) || null
                                    }
                                    onChange={handleTypeChange}
                                    options={typeOptions}
                                    isClearable
                                    placeholder="-- Select Type --"
                                />
                            </div>

                            <div className="col-4">
                                <label className="form-label">
                                    Select Program
                                </label>
                                <Select
                                    name="program_id"
                                    value={
                                        programOptions.find(
                                            (opt) =>
                                                opt.value === form.program_id
                                        ) || null
                                    }
                                    onChange={handleProgramChange}
                                    options={programOptions}
                                    isClearable
                                    placeholder="-- Select Program --"
                                    isDisabled={!programOptions.length}
                                />
                                <span className="val-message text-danger">
                                    {error?.message === "ValidationError" &&
                                        error?.data?.program_id}
                                </span>
                            </div>
                        </div>

                        <div className="row mb-3">
                            <div className="col-12">
                                <label className="form-label">
                                    Add Members
                                </label>
                                <Select
                                    name="student_ids"
                                    value={studentOptions.filter((opt) =>
                                        form.student_ids.includes(opt.value)
                                    )}
                                    onChange={handleStudentChange}
                                    options={studentOptions}
                                    isMulti
                                    isClearable
                                    placeholder="-- Select Students --"
                                    isDisabled={!studentOptions.length}
                                />
                                <span className="val-message text-danger">
                                    {error?.message === "ValidationError" &&
                                        error?.data?.student_ids}
                                </span>
                            </div>
                        </div>

                        <div className="text-end">
                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={loading}
                            >
                                <FaSave className="me-2" />{" "}
                                {loading ? "Saving..." : "Save"}
                            </button>
                        </div>
                    </form>
                </div>
            }
        />
    );
};

export default MentorAddGroup;
